export default __webpack_public_path__ + "static/media/comparison-EN-new.06d9958d.mp4";